export default __webpack_public_path__ + "static/media/Group 8.44e09b3a.png";